import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { News } from '@models';
import { IBitfCloseEvent } from '@interfaces';
import { StorageService } from '@services';
import { EBitfCloseEventStatus } from '@web/enums';

@Component({
  selector: 'prada-news-dialog',
  templateUrl: './news-dialog.component.html',
  styleUrls: ['./news-dialog.component.scss'],
})
export class NewsDialogComponent implements OnInit {
  news: News;
  currentPage = 0;

  constructor(
    public dialogRef: MatDialogRef<NewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { highlight: boolean; news: News[] },
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.showNewsByIndex(0);
  }

  next() {
    this.currentPage++;
    if (this.currentPage === this.dialogData.news.length) {
      this.dialogRef.close({
        status: EBitfCloseEventStatus.CANCEL,
      } as IBitfCloseEvent<any>);
    } else {
      this.showNewsByIndex(this.currentPage);
    }
  }

  private showNewsByIndex(index = 0) {
    const news = this.dialogData.news[index];
    if (news) {
      this.news = news;
      if (this.dialogData.highlight) {
        this.setVisitedNews(this.news);
      }
    }
  }

  private setVisitedNews(news: News) {
    if (news) {
      const newsStorage = this.storageService.data;
      if (!newsStorage.readNewsIds.find(value => value === news.id)) {
        newsStorage.readNewsIds.push(news.id);
        this.storageService.data = newsStorage;
      }
    }
  }
}
